var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { ref: "modal", staticClass: "modal fade" }, [
    _c(
      "div",
      { staticClass: "modal-dialog modal-xs", attrs: { role: "document" } },
      [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h5", { staticClass: "modal-title" }, [
              _vm._v(_vm._s(_vm.$t("kanban.card.readConfirmation.modal.title")))
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.dismiss.apply(null, arguments)
                  }
                }
              },
              [_vm._v("×")]
            )
          ]),
          _vm._v(" "),
          _vm.card
            ? _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "mb-2" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t("kanban.card.readConfirmation.modal.lastUpdate")
                      ) +
                      ": " +
                      _vm._s(
                        _vm.formatDateTime(
                          _vm.card.updatedOnForReadConfirmation ?? new Date(0)
                        )
                      ) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("table", { staticClass: "table table-striped" }, [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("kanban.card.readConfirmation.modal.user")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("th", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "kanban.card.readConfirmation.modal.hasReadLast"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("th", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("kanban.card.readConfirmation.modal.readOn")
                          )
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.card.readConfirmations, function(confirmation) {
                      return _c("tr", { key: confirmation.id }, [
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              (confirmation.user?.firstName ?? "") +
                                " " +
                                (confirmation.user?.lastName ?? "")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          confirmation.dateTime.getTime() <
                          (_vm.card.updatedOnForReadConfirmation?.getTime() ??
                            0)
                            ? _c("i", {
                                staticClass: "fas fa-times-circle text-danger"
                              })
                            : _c("i", {
                                staticClass: "fas fa-check-circle text-success"
                              })
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm.formatDateTime(confirmation.dateTime))
                          )
                        ])
                      ])
                    }),
                    0
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              { staticClass: "btn btn-secondary", on: { click: _vm.dismiss } },
              [_vm._v(_vm._s(_vm.$t("btnClose")))]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }